import Datatable from "./datatable_controller";

// Connects to data-controller="home-registration-datatable"
export default class extends Datatable {
  get columns() {
    return [
      { data: "date" },
      { data: "order_id" },
      { data: "full_name" },
      { data: "tickets_purchased" },
      { data: "status" },
      { data: "actions" },
    ];
  }

  get pageLength() {
    return 4;
  }

  get searching() {
    return false;
  }

  get ordering() {
    return false;
  }

  get lengthChange() {
    return false;
  }
}
